import React from 'react';

export default function isInViewport(ref: React.RefObject<HTMLInputElement>) {
  if (!ref || !ref.current) return false;

  const { top, left, bottom, right } = ref.current.getBoundingClientRect();

  return (
    bottom > 0 &&
    right > 0 &&
    left < (window.innerWidth || document.documentElement.clientWidth) &&
    top < (window.innerHeight || document.documentElement.clientHeight)
  );
}
